export const MESSAGES = {
  PLEASE_SELECT_REASSIGN_USER: "Please select reasign user",
  PLEASE_SELECT_VILLAGES: "Please select villages first",
};
